export default __webpack_public_path__ + "static/media/organic-stores.b89e6a5a.png";